import React, { useState } from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { FiBarChart2, FiBox, FiGrid, FiLogOut, FiMenu, FiShoppingBag, FiTruck, FiUsers, FiX } from 'react-icons/fi';
import { useAuth } from '../context/AuthContext';

const logo = '/brand/zashani-logo-wide.png';

const navItems = [
    { to: '/', label: 'Dashboard', icon: FiBarChart2, roles: ['admin', 'employee'] },
    { to: '/ventas', label: 'Ventas', icon: FiShoppingBag, roles: ['admin', 'employee'] },
    { to: '/clientes', label: 'Clientes', icon: FiUsers, roles: ['admin', 'employee'] },
    { to: '/inventario', label: 'Inventario', icon: FiBox, roles: ['admin'] },
    { to: '/catalogo-admin', label: 'Catalogo', icon: FiGrid, roles: ['admin'] },
    { to: '/reportes', label: 'Reportes', icon: FiTruck, roles: ['admin'] },
    { to: '/usuarios', label: 'Usuarios', icon: FiUsers, roles: ['admin'] },
];

const Shell = () => {
    const { user, logout } = useAuth();
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const visibleItems = navItems.filter((item) => item.roles.includes(user.role));

    return (
        <div className="app-shell">
            <aside className={`sidebar ${mobileMenuOpen ? 'is-open' : ''}`}>
                <div className="mobile-header">
                    <button
                        className="mobile-icon-button"
                        type="button"
                        onClick={() => setMobileMenuOpen((open) => !open)}
                        aria-label={mobileMenuOpen ? 'Cerrar menu' : 'Abrir menu'}
                    >
                        {mobileMenuOpen ? <FiX /> : <FiMenu />}
                    </button>
                    <div className="mobile-brand">
                        <img className="brand-logo" src={logo} alt="Zashani" />
                        <span>Ventas</span>
                    </div>
                    <button className="mobile-logout-button" type="button" onClick={logout}>
                        <FiLogOut />
                    </button>
                </div>
                <div className="brand-block">
                    <img className="brand-logo" src={logo} alt="Zashani" />
                    <span>Ventas</span>
                </div>
                <nav className="side-nav">
                    {visibleItems.map((item) => {
                        const Icon = item.icon;
                        return (
                            <NavLink key={item.to} to={item.to} end={item.to === '/'} onClick={() => setMobileMenuOpen(false)}>
                                <Icon />
                                <span>{item.label}</span>
                            </NavLink>
                        );
                    })}
                </nav>
                <button className="ghost-button logout-button" type="button" onClick={logout}>
                    <FiLogOut />
                    <span>Salir</span>
                </button>
            </aside>
            <main className="main-panel">
                <header className="topbar">
                    <div>
                        <p className="eyebrow">{user.role === 'admin' ? 'Administracion' : 'Empleado'}</p>
                        <h1>Sistema de ventas</h1>
                    </div>
                    <div className="user-pill">
                        <span className="avatar">{user.name?.charAt(0) || 'Z'}</span>
                        <strong>{user.name}</strong>
                        <span>{user.email}</span>
                    </div>
                </header>
                <Outlet />
            </main>
        </div>
    );
};

export default Shell;
